(function() {
    'use strict';

    angular
        .module('serviciosocialApp')
        .controller('SSAnioController', SSAnioController);

    SSAnioController.$inject = ['SSAnio'];

    function SSAnioController(SSAnio) {

        var vm = this;

        vm.sSAnios = [];

        loadAll();

        function loadAll() {
            SSAnio.query(function(result) {
                vm.sSAnios = result;
                vm.searchQuery = null;
            });
        }
    }
})();
